import { ILead } from "../leads/leads.types";
import { IActionItem } from "./actionItem.types";

export function buildChatActionItemUpsertPayload(
  chatActionItem: IActionItem,
  finalValues: ILead,
  extras: {
    company_outlet_uuid: string;
    name?: string;
    mobile_no?: string;
    description?: string;
    forceActionItemStatus?: IActionItem["status"];
  },
): IActionItem {
  const event = finalValues.multiple_events_list?.[0];

  // Status and drive_status_uuid are already resolved by convertExtLeadToEvtLead
  // on the chatActionItem (ext_lead). Use forceActionItemStatus as override if provided.
  const status: IActionItem["status"] = extras.forceActionItemStatus ?? chatActionItem.status;
  const actual_status = chatActionItem.actual_status ?? "";
  const drive_status_uuid = chatActionItem.drive_status_uuid ?? "";

  // Sync event fields: prefer event → lead → existing action item
  const pick = <T>(eventVal: T | undefined | null, leadVal: T | undefined | null, fallback: T | undefined | null) =>
    eventVal ?? leadVal ?? fallback;

  return {
    ...chatActionItem,
    name: extras.name ?? chatActionItem.name,
    mobile_no: extras.mobile_no ?? chatActionItem.mobile_no,
    description: extras.description ?? chatActionItem.description,
    company_outlet_uuid: extras.company_outlet_uuid,
    status,
    actual_status,
    drive_status_uuid,
    followup_date: pick(event?.followup_date, finalValues.followup_date, chatActionItem.followup_date),
    function_date: pick(event?.function_date, finalValues.function_date, chatActionItem.function_date),
    booking_date: pick(event?.booking_date, finalValues.booking_date, chatActionItem.booking_date),
    event_type: pick(event?.event_type, finalValues.event_type, chatActionItem.event_type),
    event_uuid: pick(event?.event_uuid, finalValues.event_uuid, chatActionItem.event_uuid),
    event_time: pick(event?.event_time, finalValues.event_time, chatActionItem.event_time),
    event_time_uuid: pick(event?.event_time_uuid, finalValues.event_time_uuid, chatActionItem.event_time_uuid),
    preferred_venue: pick(event?.preferred_venue, finalValues.preferred_venue, chatActionItem.preferred_venue),
    preferred_venue_uuid: pick(event?.preferred_venue_uuid, finalValues.preferred_venue_uuid, chatActionItem.preferred_venue_uuid),
    other_event_name: pick(event?.other_event_name, finalValues.other_event_name, chatActionItem.other_event_name),
    number_of_guests: pick(event?.number_of_guests, finalValues.number_of_guests, chatActionItem.number_of_guests),
    number_of_rooms: pick(event?.number_of_rooms, finalValues.number_of_rooms, chatActionItem.number_of_rooms),
    estimated_rough_revenue: pick(
      (event as any)?.estimated_rough_revenue,
      (finalValues as any)?.estimated_rough_revenue,
      chatActionItem.estimated_rough_revenue,
    ),
    guest_budget: pick(
      (event as any)?.guest_budget,
      (finalValues as any)?.guest_budget,
      chatActionItem.guest_budget,
    ),
    relation_with_customer: pick(
      (event as any)?.relation_with_customer,
      (finalValues as any)?.relation_with_customer,
      chatActionItem.relation_with_customer,
    ),
    customer_relative_name: pick(
      (event as any)?.customer_relative_name,
      (finalValues as any)?.customer_relative_name,
      chatActionItem.customer_relative_name,
    ),
    lead_source_uuid: (finalValues as any)?.lead_source_uuid ?? chatActionItem.lead_source_uuid ?? null,
    source: (finalValues as any)?.source ?? chatActionItem.source ?? null,
    email: (finalValues as any)?.email ?? chatActionItem.email ?? null,
    extras: (finalValues as any)?.extras ?? chatActionItem.extras ?? null,
    additional_contact_number:
      (finalValues as any)?.additional_contact_number ?? chatActionItem.additional_contact_number ?? [],
    payment_mode: pick(event?.payment_mode, finalValues.payment_mode, chatActionItem.payment_mode),
    cancellation_dead_reason: pick(
      event?.cancellation_dead_reason,
      finalValues.cancellation_dead_reason,
      chatActionItem.cancellation_dead_reason,
    ),
  };
}
